export class TeamProfile {
  id: string;
  name: string;
  designation: string;
  location: string;
  description: string;
  status: string;
  dzongkhaName: string;
  funFact: string;
  hobbies: string[];
  awards: string[];
  certifications: string[];
  publications: { title: string; url: string }[];
  featured_in: { title: string; url: string }[];
  social: {
    linkedin: string;
    twitter: string;
    instagram: string;
    facebook: string;
  };
  featuredPhoto: any;
  photos: any[];
  visitedDistricts?: string[];
  reviews?: any[];
  audioFile?: any;
  audioFileId?: string;
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/models/team-profile.ts